import {
    Button,
    PageHeader,
    Table,
    Modal,
    Form,
    Row,
    Col,
    Input,
    Select,
    Upload,
    Space,
    message,
  } from "antd";
  import React, { useEffect, useState } from "react";
  import { TeamOutlined, ReloadOutlined } from "@ant-design/icons";
  import { useNavigate, Link } from "react-router-dom";
  import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext"
import apis from "../../services/apis"

export default function ExpenseCategory() {
    const [categoryExpenseForm] = Form.useForm()
    const { Column } = Table;
    const { expensecategories, expensecategorydispatch, user} = useApiContext()
    const [expenseCategoryData, setExpenseCategoryData] = useState([])
    const navigate = useNavigate();
    const [isopen, setIsopen] = useState(false);
    const [expenseEdit, setExpenseEdit] = useState(false)
    const [expenseCategoryId, setExpenseCategoryId] = useState("")
    const [loading, setLoading] = useState(false)

    useEffect(()=>{
        if(expensecategories.length<1)apis.ExpenseCategory.list(expensecategorydispatch)
        setExpenseCategoryData(expensecategories)
    },[expensecategories.length<1])

    const onFinish=(values)=>{
        setLoading(true)
        if(expenseEdit){
          const newValues = {...values, id:expenseCategoryId}
          apis.ExpenseCategory.edit(expensecategorydispatch, newValues).then(res=>{
            categoryExpenseForm.resetFields();
            setLoading(false)
            setIsopen(false)
            setExpenseEdit(false)
          })
        }
        else
        {

          let newValues = {...values, id:uuid}
          apis.ExpenseCategory.create(expensecategorydispatch, newValues).then(res=>{
              categoryExpenseForm.resetFields()
              setLoading(false)
              setIsopen(false)
              message.success("Expense Category added successfully!")
          })
        }

    }

    const editExpenseCategory=(values)=>{
      setExpenseEdit(true)
      setExpenseCategoryId(values.id)
      categoryExpenseForm.setFieldsValue({
        categoryName:values.categoryName,
        description:values.description,
      })
      setIsopen(true)
      console.log("expense values", values)
    }

    const onFinishFailed=(error)=>{

    }
    const getExpenseData=()=>{
      setExpenseCategoryData(expensecategories)
    }
    const getsearchData=(e)=>{
      console.log("search critiria",e.target.value);
      if(e.target.value == "") setExpenseCategoryData(expensecategories)
        const getfilteredData = expensecategories.filter(x=>x.categoryName.toLowerCase() == e.target.value.toLowerCase());
        setExpenseCategoryData(getfilteredData)
    }
  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Expense Category List"
        subTitle="Find the list of Expense Category"
        extra={[
          <Button type='primary' onClick={()=>getExpenseData()}  icon={<ReloadOutlined />}>Refresh</Button>,
          <Button
            type="primary"
            onClick={() => setIsopen(true)}
            icon={<TeamOutlined />}
          >
            Add Expense Category
          </Button>
        ]}
      />
      <Row>
        <Col span={6}>
        <Form.Item label="Enter by Category Name" rules={[
          {
            required:true,
            message:"Please enter Category Name"
          }
        ]}>

<Input placeholder='Category Name' onKeyUp={(e)=> getsearchData(e)} />
</Form.Item>
        </Col>
      </Row>
      {
        expenseCategoryData &&

       <Table dataSource={expenseCategoryData}>
       <Column title="Category Name" dataIndex="categoryName" key="id" />
       <Column title="Description" dataIndex="description" key="id" />
       <Column   key="id" render={(text, record)=>(
        user.role == "admin" &&
         <Button type="link" size="small" onClick={()=> editExpenseCategory(record)}>
          Edit
        </Button>
       
       )}/>
       </Table>
      }
       <Modal
        visible={isopen}
        title="Add Expense Category"
        footer={null}
        
        onCancel={() => {
          setIsopen(false)
          setExpenseEdit(false)
        }}
        width={500}
      >
           <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          name="basic"
          form={categoryExpenseForm}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0"
        >
             <Form.Item
                label="Category Name"
                name="categoryName"
                rules={[
                  { required: true, message: "Please enter Category Name" },
                  {min:4, message:'Please Enter Minimum 4 Characters'}
                ]}
              >
                <Input placeholder="Please Enter Category Name" />
              </Form.Item>
              <Form.Item
                label="Description"
                name="description"
              >
                <Input.TextArea rows={2} placeholder="Please Enter Category Name" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" loading={loading} className="gx-mb-0" htmlType="submit">
                {expenseEdit ? "Update Expense Category": "Add Expense Category"}
                </Button>
              </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
